<template>
  <div class="app-container">
    <el-card>
      <condition-search :query-items="queryItems" :search-param="queryParams" @search="handleQuery" @reset="reset" />
    </el-card>

    <el-card>
      <div style="margin-bottom: 12px;">
        <el-button v-if="$btnsPermission('system:user:addTenantUser')" type="primary" size="small" class="common-btn" icon="el-icon-plus" @click="handleAdd">
          新增用户
        </el-button>

      </div>
      <el-table :data="userList" style="width: 100%"  :height="heightStyleObj"  highlight-current-row border stripe>
        <el-table-column prop="nickName" label="用户姓名" width="160" />
        <!--        <el-table-column prop="userName" label="用户账号" />-->
        <el-table-column prop="phonenumber" label="手机号码" />
        <el-table-column prop="allRoleNames" label="角色">
          <template slot-scope="{ row }">
            <span v-if="row.userType === '11'">企业管理员</span>
            <span v-else>{{ row.allRoleNames ? row.allRoleNames : '未配置' }}</span>
          </template>
        </el-table-column>
        <el-table-column width="180" prop="createTime" label="创建时间">
          <template slot-scope="scope">
            {{ parseTime(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="{ row }">
            <el-switch v-model="row.status" active-color="#13ce66" active-value="0" inactive-value="1"
                       @change="changeStatus(row.userId, $event)">
            </el-switch></template></el-table-column>

        <el-table-column label="操作" width="160">
          <template slot-scope="{ row }">
            <el-button v-if="row.userType == '12' && $btnsPermission('system:role:edit')" type="text" @click="editRow(row)">
              编辑
            </el-button>
            <el-button v-if="$btnsPermission('system:user:resetTenantUserPwd')" style="margin-left: 12px" type="text" @click="resetPassword(row)">
              重置密码
            </el-button>
            <el-button v-if="row.userType == '12' && $btnsPermission('system:role:deleteTenantRole')" class="link-btn--danger" type="text" @click="deleteRow(row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize"
                  @pagination="getList" />
    </el-card>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false">
      <div v-if="newUser.phonenumber">
        <div>用户新增成功！</div>
        <div style="display: flex; align-items: center">
          账号：{{ newUser.phonenumber }}
          <span class="ml-2">密码：{{ newUser.password }}
            <!-- <el-button
              type="primary"
              size="mini"
              @click="toModifyPassword(newUser)"
              style="margin-left: 16px"
              >修改</el-button
            > -->
          </span>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </div>
    </el-dialog>

    <EditUser :visible="userShow" :action="action" :data="currentItem" @close="userShow = false" @created="createdUser" />

    <ResetPassword v-if="passwordDialogVisible" :visible="passwordDialogVisible" :user="currentItem || ''"
                   @close="passwordDialogVisible = false" />
  </div>
</template>

<script>
import EditUser from './EditUser.vue'
import ResetPassword from './ResetPassword.vue'
import { listUser, changeUserStatus, delUser } from '@/api/system/user.js'

export default {
  name: 'User',
  components: { EditUser, ResetPassword },
  data() {
    return {
      // 遮罩层
      loading: true,
      queryItems: [
        {
          label: '关键字搜索',
          field: 'searchKey',
          type: 'input',
        },
        {
          label: '创建时间',
          field: 'createTime',
          type: 'date'
        },
        {
          label: '状态',
          field: 'userStatus',
          type: 'select',
          options: [{
            dictLabel: '正常',
            dictValue: '0'
          }, {
            dictLabel: '停用',
            dictValue: '1'
          }],
        },
      ],
      heightStyleObj: '',
      userList: [],
      total: 0,
      // 查询参数
      queryParams: {
        appId:'4',
        searchKey: '',
        userStatus: '',
        pageNum: 1,
        pageSize: 10,
        createTime: null
      },
      action: 'new',
      userShow: false,
      dialogVisible: false,
      passwordDialogVisible: false,
      currentItem: {},
      newUser: {},
    }
  },

  created() {
    this.heightStyleObj = window.innerHeight - 425 + 'px'

    this.getList()
  },

  methods: {
    /** 查询角色列表 */
    async getList() {
      this.loading = true
      const params = JSON.parse(JSON.stringify(this.queryParams))
      if (params.createTime) {
        const [createTimeStart, createTimeEnd] = params.createTime
        params.createTimeStart = createTimeStart
        params.createTimeEnd = createTimeEnd
      }
      delete params.createTime
      listUser(params)
        .then(({ rows, code, msg, total }) => {
          if (code === 200) {
            this.userList = rows
            this.total = total
          } else {
            this.$message.error(msg)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    // 修改用户状态
    changeStatus(roleId, status) {
      changeUserStatus(roleId, status)
    },

    reset() {
      this.queryParams = Object.assign(this.$data.queryParams, this.$options.data.call(this)).queryParams
      this.getList()
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },

    /** 新增按钮操作 */
    handleAdd() {
      this.userShow = true
      this.currentItem = {}
      this.action = 'new'
    },

    createdUser(payload) {
      this.newUser = payload
      this.dialogVisible = true
    },

    editRow(row) {
      this.currentItem = JSON.parse(JSON.stringify(row))
      this.userShow = true
      this.action = 'edit'
    },

    toModifyPassword() {
      this.currentItem = this.newUser
      this.dialogVisible = false
      this.passwordDialogVisible = true
    },

    resetPassword(row) {
      this.currentItem = row
      this.passwordDialogVisible = true
    },

    /** 删除按钮操作 */
    deleteRow(row) {
      this.$confirm(`确定删除用户 ${row.nickName}？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delUser(row.userId)
          .then((res) => {
            this.loading = true
            const { code, msg } = res
            if (code === 200) {
              this.$message({
                message: '删除成功！',
                type: 'success'
              })
              this.getList()
            } else {
              this.$message.error(msg)
            }
          })
          .catch((err) => {
            this.$message.error(err)
          })
          .finally(() => {
            this.loading = false
          })
      })
    }
  }
}
</script>
